export default {
    oneHanded: Symbol('one-handed'),
    twoHanded: Symbol('two-handed'),
    shield: Symbol('shield'),
    fists: Symbol('fists'),
};
